/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const PREFIX = 'PASS_';

// --- Pass Series
export const FETCH_PASS_SERIES = `${PREFIX}FETCH_PASS_SERIES`;

// --- Pass Type
export const FETCH_PASS_TYPE = `${PREFIX}FETCH_PASS_TYPE`;
export const FETCH_PASS_TYPES = `${PREFIX}FETCH_PASS_TYPES`;

// --- Reservations
export const FETCH_RESERVATION = `${PREFIX}FETCH_RESERVATION`;
export const CREATE_RESERVATION = `${PREFIX}CREATE_RESERVATION`;
export const CREATE_RESERVATIONS = `${PREFIX}CREATE_RESERVATIONS`;
export const UPDATE_RESERVATION = `${PREFIX}UPDATE_RESERVATION`;
export const UPDATE_CURRENT_RESERVATION = `${PREFIX}UPDATE_CURRENT_RESERVATION`;
export const FETCH_RESERVATIONS = `${PREFIX}FETCH_RESERVATIONS`;

// --- Address
export const VERIFY_ADDRESS = `${PREFIX}VERIFY_ADDRESS`;
